export default "__VITE_ASSET__Qrynv77m__"